<div class="row justify-content-center">
  <div class="col-lg-4 col-md-4 col-sm-12">
    <div class="card">
      <div class="card-header">
        <strong>Change Password</strong>
      </div>
      <div class="card-body">
        <form [formGroup]="userForm" (ngSubmit)="changePassword()">
          <div class="row mb-3">
            <div class="col-sm-12 mb-3">
              <div class="form-group">
                <label for="currentPassword">Current Password<span class="text-danger">*</span></label>
                <input id="currentPassword" class="form-control" type="password" formControlName="currentPassword">
                <div
                  *ngIf="userForm.get('currentPassword')?.invalid && (userForm.get('currentPassword')?.dirty || userForm.get('currentPassword')?.touched)">
                  <small class="text-danger">Current Password is required.</small>
                </div>
              </div>
            </div>

            <div class="col-sm-12 mb-3">
              <div class="form-group">
                <label for="newPassword">New Password<span class="text-danger">*</span></label>
                <input id="newPassword" class="form-control" type="password" formControlName="newPassword">
                <div
                  *ngIf="userForm.get('newPassword')?.invalid && (userForm.get('newPassword')?.dirty || userForm.get('newPassword')?.touched)">
                  <small class="text-danger">New Password is required.</small>
                </div>
              </div>
            </div>

            <div class="col-sm-12 mb-3">
              <div class="form-group">
                <label for="confirmNewPassword">Confirm Password<span class="text-danger">*</span></label>
                <input id="confirmNewPassword" class="form-control" type="password" formControlName="confirmNewPassword">
                <div
                  *ngIf="userForm.get('confirmNewPassword')?.invalid && (userForm.get('confirmNewPassword')?.dirty || userForm.get('confirmNewPassword')?.touched)">
                  <small class="text-danger">Confirm Password is required.</small>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <button type="submit" class="md-btn-primary mr-2 float-right">Submit</button>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <button type="button" class="md-btn-secondary ml-2" (click)="onReset()">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>